import Component from "flarum/common/Component";

export default class CategoryItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.collapsed = true;
    this.isCollapsible = window.innerWidth < 768;

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  onremove() {
    window.removeEventListener("resize", this.handleResize.bind(this));
  }

  handleResize() {
    this.isCollapsible = window.innerWidth < 768;
    m.redraw();
  }

  view() {
    const {
      isMainCategory,
      title,
      icon,
      description,
      link,
      terminalPost,
      stats,
      className,
    } = this.attrs;

    return (
      <div className={`CategoryItem ${className}`}>
        <div
          className={`${link ? "hasLink" : ""}`}
          onclick={() => (link ? m.route.set(link) : null)}
        >
          <div className={`CategoryItem-header`}>
            <h4 className="CategoryItem-headerTitle">
              {isMainCategory && (
                <span>
                  <i className={icon} />
                </span>
              )}

              {title}

              {this.isCollapsible && !isMainCategory && (
                <div
                  className="CategoryItem-headerToggle"
                  onclick={(e) => {
                    e.stopPropagation();
                    this.toggle.bind(this)();
                  }}
                >
                  <div className="Collapsible-headerToggleIcon">
                    <i
                      className={`fas fa-chevron-${this.collapsed ? "down" : "up"}`}
                    />
                  </div>
                </div>
              )}
            </h4>
          </div>

          {this.isCollapsible ? (
            <div className="CategoryItem-content">
              <div className="CategoryItem-description">
                <p>{description}</p>
              </div>

              {(isMainCategory || !this.collapsed) && (
                <div className="CategoryItem-collapsible">
                  <div>
                    {terminalPost && (
                      <>
                        <i className="fas fa-reply"></i>
                        <p className="CategoryItem-terminalPost">
                          {terminalPost}
                        </p>
                      </>
                    )}
                  </div>

                  {stats && (
                    <div
                      className={`CategoryItem-stats ${isMainCategory ? "" : "subCategory"}`}
                    >
                      {stats.map((stat) => (
                        <div className="CategoryItem-stat">
                        <p>
                          <span className="stat-number">
                            {this.formatNumber(stat.number)}
                          </span>

                          <span className="stat-label">
                            <i className={stat.icon} />
                          </span>
                        </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className="CategoryItem-content">
              <div className="CategoryItem-description">
                <p>{description}</p>
                
                {terminalPost && (
                  <p className="CategoryItem-terminalPost">
                    <i className="fas fa-reply"></i>
                    {terminalPost}
                </p>
                )}
              </div>

              {stats && (
                <div
                  className={`CategoryItem-stats ${isMainCategory ? "" : "subCategory"}`}
                >
                  {stats.map((stat) => (
                    <div className="CategoryItem-stat">
                      <p>
                        <span className="stat-number">
                          {this.formatNumber(stat.number)}
                        </span>

                        <span className="stat-label">
                          <i className={stat.icon} />
                          {stat.label && ` ${stat.label}`}
                        </span>
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  toggle() {
    this.collapsed = !this.collapsed;
  }

  formatNumber(number) {
    return number >= 1000 ? `${(number / 1000).toFixed(0)}K` : number;
  }
}
